import { createAction } from 'redux-actions';

export const aceptarTerminosAction = createAction('PAGINA_PAGO_ACEPTAR_TERMINOS_CONDICIONES');

export const setLoadingAction = createAction('PAGINA_PAGO_SET_LOADING');
